import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeissmanSharedModule } from '../Common/weissman-shared.module';
import { TeamModule } from '../Team/team.module';
import { AceTabSetModule } from '../UI-Lib/ACE/Tab-Set/tabSet.module';
import { ContactListPageComponent } from './Page/contactListPage.component';
import { ContactPanelUpgradeDirective } from './Panel/contact.panel.upgrade.component';
import { ContactPanelComponent } from './Panel/contactPanel.component';
import { ContactListComponent } from './Panel/List/contactList.component';
import { UserModule } from '../User/user.module';
import { HybridAdapterUtility } from '../Hybrid/hybrid-adapter.utility';
import { ContactsRepository } from '../Core-Repositories';
import { ContactPanelBodyActionsComponent } from './Panel/Body-Actions/panelBodyActions.component';
import { ContactListModalComponent } from './Panel/List/Associate-Contact/contactListModal.component';
import { EditRoleModalComponent } from './Panel/List/Edit-Role/editRoleModal.component';
import { ContactModalComponent } from './View/contactModal.component';

@NgModule({
    imports: [
        CommonModule,
        WeissmanSharedModule,
        UserModule,
        TeamModule,
        AceTabSetModule,

        // Standalone Components
        ContactPanelComponent,
        ContactListComponent,
        ContactPanelBodyActionsComponent,
    ],
    declarations: [
        ContactPanelUpgradeDirective,
        ContactListModalComponent,
        ContactListPageComponent,
        EditRoleModalComponent,
        ContactModalComponent
    ],
    providers: [
        ContactsRepository
    ],
    exports: [
        ContactPanelComponent,
        ContactListPageComponent
    ]
})
export class ContactModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('sdContactsPanel', ContactPanelComponent);
        hybridAdapterUtility.downgradeNg2Component('sdEntityContactList', ContactListModalComponent);
        hybridAdapterUtility.downgradeNg2Component('contactListPage', ContactListPageComponent);
    }
}
